import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_comm_include_any_of_the_following_select_all_that_a'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_comm_include_any_of_the_following_select_all_that_a',
  name: 'Did the facility communication include any of the following?:',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ENGAGEMENT_WITH_NGOS_AND_OTHER_EXTERNAL_STAKEHOLDERS',
      text: 'Engagement with NGOs and other external stakeholders',
      externalIds: [
        {
          id: 'ab-14--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SOCIAL_LABOR_POLICIES_AND_PROCEDURES',
      text: 'Social/labor policies and procedures',
      externalIds: [
        {
          id: 'ab-14--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'RESULTS_OF_SOCIAL_COMPLIANCE_MONITORING',
      text: 'Results of social compliance monitoring',
      externalIds: [
        {
          id: 'ab-14--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ISSUES_IDENTIFIED_ACTIONS_TAKEN_AND_RESULTS_ACHIEVED_IN_RESPONS',
      text: 'Issues identified, actions taken, and results achieved in response to results of social compliance monitoring',
      externalIds: [
        {
          id: 'ab-14--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'INDIRECT_SUPPLIER_LIST',
      text: 'Indirect supplier list',
      externalIds: [
        {
          id: 'ab-14--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST',
      text: 'Facility/company/group reporting externally on progress against social compliance goals and objectives per Global Reporting Initiative (GRI) requirements ',
      externalIds: [
        {
          id: 'ab-14--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST_GLOBAL',
      text: 'Facility/company/group reporting externally on progress against social compliance goals and objectives per International Sustainability Standards Board (ISSB, formerly SASB Standards) requirements',
      externalIds: [
        {
          id: 'ab-com-22',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-14--1-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_PROVIDE_DETAILS_OF_THE_HOUSING_ARRANGEMENTS_INCLUDING_AT',
      text: 'Please provide details of the housing arrangements, including at minimum how many workers are living in the building, who is managing the building and what is the relationship between the facility and the entity providing the housing:',
      externalIds: [
        {
          id: 'fp-bui-2f',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WHERE_IN_THE_COUNTRY_ARE_THE_DOMESTIC_MIGRANT_WORKERS_FROM_',
      text: 'Where in the country are the domestic migrant workers from?',
      externalIds: [
        {
          id: 'fp-wor-33f',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ENGAGEMENT_WITH_NGOS_AND_OTHER_EXTERNAL_STAKEHOLDERS',
                'SOCIAL_LABOR_POLICIES_AND_PROCEDURES',
                'RESULTS_OF_SOCIAL_COMPLIANCE_MONITORING',
                'ISSUES_IDENTIFIED_ACTIONS_TAKEN_AND_RESULTS_ACHIEVED_IN_RESPONS',
                'INDIRECT_SUPPLIER_LIST',
                'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST',
                'FACILITY_COMPANY_GROUP_REPORTING_EXTERNALLY_ON_PROGRESS_AGAINST_GLOBAL',
                'NONE_OF_THE_ABOVE',
                'PLEASE_PROVIDE_DETAILS_OF_THE_HOUSING_ARRANGEMENTS_INCLUDING_AT',
                'WHERE_IN_THE_COUNTRY_ARE_THE_DOMESTIC_MIGRANT_WORKERS_FROM_',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-com-19',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25400,
  sectionId: '2.2.11.1',
  impactArea: 'Transparency',
  impactAreaId: 'TRANSPARENCY',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
